import React from "react";
import {
	Home,
	Settings,
	Briefcase,
	FileText,
	Folder,
	List,
	User,
	Users,
	UserCog,
	Stethoscope,
	Files,
	File,
	Clipboard,
	Archive,
	Plus,
	Edit,
	Search,
	Check,
	Clock,
	History,
	Calendar,
	CreditCard,
	DollarSign,
	MessageCircle,
	Mail,
	Phone,
	StickyNote,
	Shield,
	Info,
	HelpCircle,
	Tag,
	Bookmark,
	Heart,
	Star,
	Building,
	Package,
	Truck,
	ShoppingCart,
	Gift,
	Award,
	Trophy,
	Target,
	Activity,
	AlertCircle,
	Bell,
	Camera,
	Image,
	Paperclip,
	Link,
	Globe,
	Map,
	Navigation,
	Compass,
	BarChart,
	PieChart,
	TrendingUp,
	Layers,
	Grid,
	Layout,
	Database,
	Server,
	Cpu,
	Zap,
	Wifi,
	Lock,
	Unlock,
	Key,
	Eye,
	EyeOff,
	Download,
	Upload,
	Share,
	Send,
	Inbox,
	Trash,
	RefreshCw,
	RotateCw,
	Save,
	Copy,
	Scissors,
	Printer,
	Book,
	BookOpen,
	Newspaper,
	PenTool,
	Palette,
	Music,
	Video,
	Mic,
	Headphones,
	Volume2,
	Sun,
	Moon,
	Cloud,
	Umbrella,
	Thermometer,
	Coffee,
	Pizza,
	Apple,
	Flag,
	MapPin,
	Hash,
	AtSign,
	Percent,
	Calculator,
	Sigma,
	type LucideIcon,
} from "lucide-react";

// Map of icon names to icon components
const iconMap: Record<string, LucideIcon> = {
	// General
	Home: Home,
	Settings: Settings,
	Briefcase: Briefcase,
	FileText: FileText,
	Folder: Folder,
	List: List,

	// People
	User: User,
	Users: Users,
	UserCog: UserCog,
	Stethoscope: Stethoscope,

	// Files
	Files: Files,
	File: File,
	Clipboard: Clipboard,
	Archive: Archive,

	// Actions
	Plus: Plus,
	Edit: Edit,
	Search: Search,
	Check: Check,

	// Time
	Clock: Clock,
	History: History,
	Calendar: Calendar,

	// Finance
	CreditCard: CreditCard,
	DollarSign: DollarSign,

	// Communication
	MessageCircle: MessageCircle,
	Mail: Mail,
	Phone: Phone,

	// Other commonly used
	StickyNote: StickyNote,
	Shield: Shield,
	Info: Info,
	HelpCircle: HelpCircle,
	Tag: Tag,
	Bookmark: Bookmark,
	Heart: Heart,
	Star: Star,
	Building: Building,
	Package: Package,
	Truck: Truck,
	ShoppingCart: ShoppingCart,
	Gift: Gift,
	Award: Award,
	Trophy: Trophy,
	Target: Target,
	Activity: Activity,
	AlertCircle: AlertCircle,
	Bell: Bell,
	Camera: Camera,
	Image: Image,
	Paperclip: Paperclip,
	Link: Link,
	Globe: Globe,
	Map: Map,
	Navigation: Navigation,
	Compass: Compass,
	BarChart: BarChart,
	PieChart: PieChart,
	TrendingUp: TrendingUp,
	Layers: Layers,
	Grid: Grid,
	Layout: Layout,
	Database: Database,
	Server: Server,
	Cpu: Cpu,
	Zap: Zap,
	Wifi: Wifi,
	Lock: Lock,
	Unlock: Unlock,
	Key: Key,
	Eye: Eye,
	EyeOff: EyeOff,
	Download: Download,
	Upload: Upload,
	Share: Share,
	Send: Send,
	Inbox: Inbox,
	Trash: Trash,
	RefreshCw: RefreshCw,
	RotateCw: RotateCw,
	Save: Save,
	Copy: Copy,
	Scissors: Scissors,
	Printer: Printer,
	Book: Book,
	BookOpen: BookOpen,
	Newspaper: Newspaper,
	PenTool: PenTool,
	Palette: Palette,
	Music: Music,
	Video: Video,
	Mic: Mic,
	Headphones: Headphones,
	Volume2: Volume2,
	Sun: Sun,
	Moon: Moon,
	Cloud: Cloud,
	Umbrella: Umbrella,
	Thermometer: Thermometer,
	Coffee: Coffee,
	Pizza: Pizza,
	Apple: Apple,
	Flag: Flag,
	MapPin: MapPin,
	Hash: Hash,
	AtSign: AtSign,
	Percent: Percent,
	Calculator: Calculator,
	Sigma: Sigma,
};

// German labels for icons
export const iconLabels: Record<string, string> = {
	// General
	Home: "Startseite",
	Settings: "Einstellungen",
	Briefcase: "Aktenkoffer",
	FileText: "Textdatei",
	Folder: "Ordner",
	List: "Liste",

	// People
	User: "Benutzer",
	Users: "Benutzer (Gruppe)",
	UserCog: "Benutzerverwaltung",
	Stethoscope: "Stethoskop",

	// Files
	Files: "Dateien",
	File: "Datei",
	Clipboard: "Zwischenablage",
	Archive: "Archiv",

	// Actions
	Plus: "Hinzufügen",
	Edit: "Bearbeiten",
	Search: "Suchen",
	Check: "Häkchen",

	// Time
	Clock: "Uhr",
	History: "Verlauf",
	Calendar: "Kalender",

	// Finance
	CreditCard: "Kreditkarte",
	DollarSign: "Währung",

	// Communication
	MessageCircle: "Nachricht",
	Mail: "E-Mail",
	Phone: "Telefon",

	// Other commonly used
	StickyNote: "Notiz",
	Shield: "Schutz",
	Info: "Information",
	HelpCircle: "Hilfe",
	Tag: "Etikett",
	Bookmark: "Lesezeichen",
	Heart: "Herz",
	Star: "Stern",
	Building: "Gebäude",
	Package: "Paket",
	Truck: "Lieferwagen",
	ShoppingCart: "Einkaufswagen",
	Gift: "Geschenk",
	Award: "Auszeichnung",
	Trophy: "Trophäe",
	Target: "Ziel",
	Activity: "Aktivität",
	AlertCircle: "Warnung",
	Bell: "Glocke",
	Camera: "Kamera",
	Image: "Bild",
	Paperclip: "Büroklammer",
	Link: "Verknüpfung",
	Globe: "Globus",
	Map: "Karte",
	Navigation: "Navigation",
	Compass: "Kompass",
	BarChart: "Balkendiagramm",
	PieChart: "Kreisdiagramm",
	TrendingUp: "Trend aufwärts",
	Layers: "Ebenen",
	Grid: "Raster",
	Layout: "Layout",
	Database: "Datenbank",
	Server: "Server",
	Cpu: "Prozessor",
	Zap: "Blitz",
	Wifi: "WLAN",
	Lock: "Gesperrt",
	Unlock: "Entsperrt",
	Key: "Schlüssel",
	Eye: "Auge",
	EyeOff: "Auge aus",
	Download: "Herunterladen",
	Upload: "Hochladen",
	Share: "Teilen",
	Send: "Senden",
	Inbox: "Posteingang",
	Trash: "Papierkorb",
	RefreshCw: "Aktualisieren",
	RotateCw: "Drehen",
	Save: "Speichern",
	Copy: "Kopieren",
	Scissors: "Schere",
	Printer: "Drucker",
	Book: "Buch",
	BookOpen: "Buch offen",
	Newspaper: "Zeitung",
	PenTool: "Stift",
	Palette: "Palette",
	Music: "Musik",
	Video: "Video",
	Mic: "Mikrofon",
	Headphones: "Kopfhörer",
	Volume2: "Lautstärke",
	Sun: "Sonne",
	Moon: "Mond",
	Cloud: "Wolke",
	Umbrella: "Regenschirm",
	Thermometer: "Thermometer",
	Coffee: "Kaffee",
	Pizza: "Pizza",
	Apple: "Apfel",
	Flag: "Flagge",
	MapPin: "Kartennadel",
	Hash: "Hashtag",
	AtSign: "At-Zeichen",
	Percent: "Prozent",
	Calculator: "Taschenrechner",
	Sigma: "Summe",
};

// Get all available icon names
export const availableIcons = Object.keys(iconMap);

// Group icons by category for better organization
export const iconCategories = {
	Allgemein: ["Home", "Settings", "Briefcase", "FileText", "Folder", "List"],
	Personen: ["User", "Users", "UserCog", "Stethoscope"],
	Dateien: ["Files", "File", "Clipboard", "Archive", "Paperclip"],
	Aktionen: ["Plus", "Edit", "Search", "Check", "Save", "Copy", "Share"],
	Zeit: ["Clock", "History", "Calendar"],
	Finanzen: ["CreditCard", "DollarSign", "ShoppingCart", "Gift", "Sigma"],
	Kommunikation: ["MessageCircle", "Mail", "Phone", "Send", "Inbox"],
	Diagramme: ["BarChart", "PieChart", "TrendingUp", "Activity"],
	System: ["Database", "Server", "Cpu", "Lock", "Shield", "Key"],
	UI: ["Layout", "Grid", "Layers", "Eye", "Bell", "Info"],
	Sonstiges: [
		"StickyNote",
		"Tag",
		"Bookmark",
		"Heart",
		"Star",
		"Flag",
		"MapPin",
	],
};

// Get icon component by name
export function getIconComponent(
	iconName: string | undefined
): LucideIcon | null {
	if (!iconName) return null;
	return iconMap[iconName] || null;
}

// Render icon by name with props
export function renderIcon(
	iconName: string | undefined,
	props?: React.ComponentProps<LucideIcon>
): React.ReactNode {
	const IconComponent = getIconComponent(iconName);
	if (!IconComponent) return null;
	return <IconComponent {...props} />;
}
